import axios from 'axios'

const baseDomain = 'https://profiteia-content.azurewebsites.net'
const baseURL = `${baseDomain}/graphql`

export default axios.create({
  baseURL
})
